import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import Ticker from '@/pages/home/components/Ticker';
import NewsFeed from '@/pages/home/components/NewsFeed';
import FeaturedCollections from '@/pages/home/components/FeaturedCollections';
import DownloadHub from '@/pages/home/components/DownloadHub';
import BoardZones from '@/pages/home/components/BoardZones';
import Discussions from '@/pages/home/components/Discussions';
import GalleryPreview from '@/pages/home/components/GalleryPreview';
import RankingBoard from '@/pages/home/components/RankingBoard';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Header />
      <main className="w-full">
        <Hero />
        <Ticker />
        <NewsFeed />
        <FeaturedCollections />
        <DownloadHub />
        <BoardZones />
        <Discussions />
        <GalleryPreview />
        <RankingBoard />
      </main>
      <Footer />
    </div>
  );
}